<template>
	<v-flex xs12 class="background">
		<v-layout wrap align-center class="body-row" :class="{ 'body-row-color' : index % 2 }" v-if="codeReports === 'balance-sheet' || codeReports === 'result-status'">
			<v-flex
				v-for="column in columns"
				:key="column.id"
				class="row-height border-right border-left"
				:class="{ 'bold': isOpen, [column.class] : column.class }"
				:style="styleByBalance(column)"
				@click="toggle"
			>
				<span
					v-if="isFolder && column.icon"
					:class="{ 'pl-0': item.level === 1 }"
				>
					<v-btn icon class="ma-0 btn-action btn-auto">
						<v-icon style="color: #00BFA5 !important;" size="18">
							{{ isOpen ? 'remove_circle_outline' : 'add_circle_outline' }}
							<!-- <template v-if="isOpen">
								remove_circle_outline
							</template>
							<template v-else>
								add_circle_outline
							</template> -->
						</v-icon>
					</v-btn>
                    &nbsp;&nbsp;&nbsp;&nbsp;{{item[column.value]}}
				</span>
				<span
					class="align-center"
					:class="{ 'pl-0': item.accountingAccountCode && !isFolder, 'ml-0' : column.value === 'accumulated' }"
					:style="styleByNoFolders(column)"
					v-else-if="column.value !== 'actions'"
				>
					<template>
						<template v-if="item[column.value]">
							<template>
								{{ column.value === 'balance' ? formatData(item[column.value]): item[column.value] }}
							</template>
						</template>
					</template>
				</span>
			</v-flex>
			<v-layout wrap v-show="isOpen" v-if="isFolder">
				<tree-item
					:columns="columns"
					class="item"
					v-for="(child, index) in item.details"
					:key="index"
					:item="child"
					:open="child.open"
					:code-reports="codeReports"
					@row-expanded="$emit('row-expanded', $event)"
				></tree-item>
			</v-layout>
		</v-layout>


		<v-layout wrap align-center class="body-row" :class="{ 'body-row-color' : index % 2 }" v-if="codeReports === 'checking-balance'">
			<v-flex
				v-for="column in columns"
				:key="column.id"
				text-xs-left
				class="row-height border-right border-left"
				:class="{ 'bold': isOpen, [column.class] : column.class }"
				:style="isFolder && (column.value === 'account' || column.value === 'name') ? `padding-left: calc(${item.level} * 10px)` : ``"
				@click="toggle"
			>
				<span
					v-if="isFolder && column.icon"
					:class="{ 'pl-0': item.level === 1 }"
				>
					<v-btn icon class="ma-0 btn-action btn-auto">
						<v-icon color="teal accent-4" size="18">
							<template v-if="isOpen">
								remove_circle_outline
							</template>
							<template v-else>
								add_circle_outline
							</template>
						</v-icon>
					</v-btn>
                    &nbsp;&nbsp;&nbsp;&nbsp;{{item[column.value]}}
				</span>
				<span
					class="align-center"
					:class="{ 'pl-0': item.accountingAccountCode && !isFolder, 'ml-0' : column.value === 'accumulated' }"
					:style="!isFolder && (column.value === 'account' || column.value === 'name') ? `margin-left: calc((${item.level} * 10px) + (10px * (${item.level} - 2)))` : `margin-left: 11px;`"
					v-else-if="column.value !== 'actions'"
				>
					<template>
						<template v-if="item[column.value]"
						>
							<template
							>
								{{ column.value === 'previousBalance' || column.value === 'debit' || column.value === 'credit'  || column.value === 'debitBalance' || column.value === 'creditBalance' 
									? formatData(item[column.value]) : item[column.value] }}
							</template>
						</template>
					</template>
				</span>
			</v-flex>
			<v-layout wrap v-show="isOpen" v-if="isFolder">
				<tree-item
					:columns="columns"
					class="item"
					v-for="(child, index) in item.details"
					:key="index"
					:item="child"
					:open="child.open"
					:code-reports="codeReports"
					@row-expanded="$emit('row-expanded', $event)"
				></tree-item>
			</v-layout>
		</v-layout>
	</v-flex>
</template>
<script>
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function disabledCreate() {
		return this.createPlan && !this.item.codeCreated;
	}

	function disabledEdit() {
		return this.item.accountingAccountCode && this.createPlan && !this.item.codeCreated;
	}

	function isFolder() {
		return (this.item.flagParent && !this.item.details) ||
			(this.item.details && this.item.details.length > 0);
	}

	function toggle() {
		if (this.isFolder) {
			this.$emit('row-expanded', this.item);
			this.isOpen = !this.isOpen;
		}
	}

	function open(val) {
		this.isOpen = val;
	}

	function data() {
		return {
			isOpen: this.open,
		};
	}

	function styleByBalance(column) {
		let style = '';
		if (this.isFolder && column.value === 'balance') {
			style = 'text-align: end; padding-right: 20px';
		} else if (!this.isFolder && column.value === 'balance') {
			style = 'color: #0071d6; text-align: end; padding-right: 20px';
		} else if (!this.isFolder && column.value !== 'balance') {
			style = 'color: #0071d6; padding-left: 9px';
		} else if (this.isFolder) {
			style = `padding-left: calc(${this.item.level} * 10px)`;
		}
		return style;
	}

	function styleByNoFolders(column) {
		let style = '';
		if (!this.isFolder && column.value !== 'balance') {
			style = `margin-left: calc((${this.item.level} * 8px) + (10px * (${this.item.level} - 2)))`;
		} else if (this.isFolder) {
			style = 'margin-left: 11px';
		}
		return style;
	}

	function formatData(value) {
		if (typeof value !== 'string') {
			return parseFloat(value).toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		}
		return value;
	}

	export default {
		name: 'tree-item',
		components: {
			appTooltipButton,
		},
		computed: {
			isFolder,
		},
		data,
		methods: {
			disabledCreate,
			disabledEdit,
			toggle,
			styleByBalance,
			styleByNoFolders,
			formatData,
		},
		props: {
			columns: {
				default: () => [],
				type: Array,
			},
			createPlan: {
				default: false,
				type: Boolean,
			},
			index: [Number, String],
			item: Object,
			open: {
				default: false,
				type: Boolean,
			},
			showNameCode: {
				default: false,
				type: Boolean,
			},
			codeReports: {
				default: '',
				type: String,
			},
		},
		watch: {
			open,
		},
	};
</script>

<style lang="scss" scoped>
	.body-row {
		background-color: color(white);
		color: #2c404a;
		font-family: font(open-regular);
		font-size: size(small11);

		&-color {
			background-color: #f4f6f8;
		}
	}

	.bold {
		font-family: font(open-bold);
	}

	.border-left {
		border-left: 1px solid #e0e5e8;
	}

	.border-right {
		border-right: 1px solid #e0e5e8;
	}

	.row-height {
		border-bottom: 1px solid #e0e5e8;
		height: 30px;
		line-height: 28px;

		.align-center {
			vertical-align: top;
		}
	}

	.wrapper-action {
		display: flex;
		justify-content: space-around;
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/accountant/tree-item.vue